import { Route, Routes } from "react-router-dom";
import "./App.css";
import Login from "./pages/Login/Login";
import Home from "./pages/Home/Home";
import Restaurants from "./pages/Restaurants/Restaurants";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Home />} />
        <Route path="/restraunts" element={<Restaurants />} />
      </Routes>
    </div>
  );
}

export default App;
